import React from "react";
import ATRONRewards from '../subcomponents_floatie/ATRONRewards';
import AUSDRewards from '../subcomponents_floatie/AUSDRewards';
import ULTRARewards from '../subcomponents_floatie/ULTRARewards';
import ROCKETFIRewards from '../subcomponents_floatie/ROCKETFIRewards';
import RTRRewards from "../subcomponents_floatie/RTRRewards";
import YinYangRewards from "../subcomponents_floatie/YinYangRewards";
import DividendTokenRewards from "../subcomponents_floatie/DividendTokenRewards";


const rewardComponentMap = {
    // Exact label => component
    'ATRON': ATRONRewards,
    'AUSD': AUSDRewards,
    'ROCKETFI': ROCKETFIRewards,
    'RTR': RTRRewards,
    // For YIN & YANG, they share the same component
    'YIN': YinYangRewards,
    'Yang': YinYangRewards,
    // If these tokens share the same DividendTokenRewards logic:
    'TMT': DividendTokenRewards,
    'ABTC': DividendTokenRewards,
    'ADACash': DividendTokenRewards,
    'SOLCash': DividendTokenRewards,
    'PRT': DividendTokenRewards,
    'ESP': DividendTokenRewards,
    'COW': DividendTokenRewards,
    '$STAG': DividendTokenRewards,
    'ULTRARewards': ULTRARewards,
};

const isUltraToken = (label) => label?.includes("ULTRA");

const RewardsPending = ({
    token,
    account,
    contracts,
    tokenSelections,
    imageReferences,
    enableClaiming = false,
    refreshData
  }) => {
    
    // Utility function to pick the correct component from the map
    const getRewardsComponent = () => {
      if (!token?.label) return null;
  
      // If label includes "ULTRA" 
      if (isUltraToken(token.label)) {
        const ULTRARewards = rewardComponentMap.ULTRARewards; // you could also store a `ULTRA` key in the map
        return ULTRARewards
          ? <ULTRARewards
              token={token}
              account={account}
              contracts={contracts}
              enableClaiming={enableClaiming}
              refreshData={refreshData}
              // any other props you need
            />
          : null;
      }
  
      // Otherwise look up the label directly in the map
      const RewardComponent = rewardComponentMap[token.label];
      if (RewardComponent) {
        return (
          <RewardComponent
            token={token}
            account={account}
            contracts={contracts}
            tokenSelections={tokenSelections}
            imageReferences={imageReferences}
            enableClaiming={enableClaiming}
            refreshData={refreshData}
            viewTotalDistributed={true}
          />
        );
      }
  
      // If nothing matches, return null or an empty string
      return null;
    };
  
    return (
      <div style={{ marginTop: '10px' }}>
        {getRewardsComponent()}
      </div>
    );
  };
  
  export default React.memo(RewardsPending);
